<script src="../../../app-routing.module.ts"></script>
<app-search-filter-bar
  [useFilter]="false"
  [useSearchBar]="false"
  [useBackNavigation]="knowledgeBaseService.activePage() == 0 || knowledgeBaseService.activePage() == 3"
  (navigateBack)="knowledgeBaseService.goBack()"
></app-search-filter-bar>

<div class="container-fluid p-4">
  <div class="row justify-content-evenly">
    <div
      class="col-12 mb-1"
      *ngIf="
        knowledgeBaseService.activePage() == 0 &&
        userService.userrole() !== Userrole.Mitarbeiter
      "
    >
      <app-kd-workplace-selection></app-kd-workplace-selection>
    </div>
    <div class="col-12 mb-3" *ngIf="knowledgeBaseService.activePage() == 1">
      <app-kd-workplace></app-kd-workplace>
    </div>
    <div class="col-12" *ngIf="knowledgeBaseService.activePage() === 2">
      <app-kd-solution></app-kd-solution>
    </div>
  </div>
  <div class="footer-action-button d-flex justify-content-end mt-3" *ngIf="!reportService.isSendingEmailNotification()">
    <button [routerLink]="'/dashboard'" class="btn btn-qundis-escalate"
            (click)="reportService.cancelReport$.next()">Erfassung abbrechen
    </button>
  </div>

</div>
